// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hint-tooltip {
  color: #d8d9db;
}
.hint-tooltip i {
  display: inline-block;
  vertical-align: middle;
}

[class*=hint--]:after {
  font-size: 12px;
  max-width: 300px;
}`, "",{"version":3,"sources":["webpack://./src/components/Hint/Hint.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;AACD;AAAC;EACC,qBAAA;EACA,sBAAA;AAEF;;AACA;EACC,eAAA;EACA,gBAAA;AAED","sourcesContent":[".hint-tooltip {\n\tcolor: #d8d9db;\n\ti {\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t}\n}\n[class*=\"hint--\"]:after {\n\tfont-size: 12px;\n\tmax-width: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
